export function shouldUploadDuringRecordingFinalize({
  canUpload,
  userId,
  isOnline,
  iosNetworkOptionalMode,
} = {}) {
  return Boolean(canUpload && userId && isOnline && !iosNetworkOptionalMode);
}
